import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, TextInput } from 'components/Form'
import { createApiRecord, updateApiRecord } from 'services/CompanyService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { getCompanyData } from 'store/data/dataSlice'
import { Tabs } from 'components/Ui'
import ApiConfigurationTabView from './components/ApiConfigurationTabView'
injectReducer('company', reducer)

const validationSchema = Yup.object().shape({
    name: Yup.string().required('company name field is required'),
    code: Yup.string().required('code field is required'),
    domain: Yup.string().required('domain field is required'),
})

const Create = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { view, record, loading } = useSelector(state => state.company.data)
    const { companyData } = useSelector(state => state.listData)

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = id => dispatch(getRecord(id))

    const handleDiscard = () => navigate('/company-management/company')

    const handleSubmit = data => {
        if (id) {
            updateApiRecord(id, data)
                .then(() => {
                    Success('Company Updated Successfully!')
                    // handleDiscard()
                    dispatch(getCompanyData())
                })
                .catch(error => console.log('Error: ', error))
        } else {
            createApiRecord(data)
                .then(response => {
                    Success('Company Created Successfully!')
                    // handleDiscard()
                    navigate(`/company-management/company/${response?.data?.id}/edit`)
                    dispatch(getCompanyData())
                })
                .catch(error => console.log('Error: ', error))
        }
    }

    if (loading) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Company</h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">{id ? 'Update Company' : 'Add New Company'}</h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={id ? record : view}
                            validationSchema={validationSchema}
                            onSubmit={values => {
                                handleSubmit(values)
                            }}
                        >
                            {({ values, touched, errors }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-4">
                                        <Field name="name">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Company Name"
                                                    name="name"
                                                    error={errors.name && touched.name}
                                                    message={errors.name}
                                                    value={values?.name}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                        <Field name="code">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Code"
                                                    name="code"
                                                    error={errors.code && touched.code}
                                                    message={errors.code}
                                                    value={values?.code}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                        <Field name="domain">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Domain"
                                                    name="domain"
                                                    error={errors.domain && touched.domain}
                                                    message={errors.domain}
                                                    value={values?.domain}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                    {id ? (
                        <div className="px-5 py-3 border-t border-stroke dark:border-strokedark">
                            <Tabs.Group version={1}>
                                <Tabs.List>
                                    <Tabs>Api Configuration</Tabs>
                                </Tabs.List>
                                <Tabs.Panels className="mt-4">
                                    <Tabs.Panel>
                                        <ApiConfigurationTabView companyData={companyData} record={record} />
                                    </Tabs.Panel>
                                </Tabs.Panels>
                            </Tabs.Group>
                        </div>
                    ) : null}
                </div>
            </div>
        </>
    )
}

export default Create
